/**
 * @requires ./frc.js
 */

frc.modules.reservations = function($module){
	var self = this;
	self.config = {
	};
	self.data = {
		"$module": null,
		"$form": null,
		"version": null
	};

	if((typeof $module)=="string"){
		$module = $($module);
	}

	self.data.$module = $module;

	self.init = function() {

		self.data.version = self.data.$module.attr("data-module-version");

		self.data.fields = {
			"location": self.data.$module.find(".s_location"),
			"date": self.data.$module.find(".s_date"),
			"altDate": self.data.$module.find(".s_altdate"),
			"time": self.data.$module.find(".s_time"),
			"partySize": self.data.$module.find(".s_party")
		};

		// DEBUG
		// self.data.fields.date.css('border', '2px solid magenta');

		// Validation

		self.data.fields.location.on("invalid", function(e) {
			e.target.setCustomValidity("Please select a location");
		});
		self.data.fields.date.on("invalid", function(e) {
			e.target.setCustomValidity("Please select a date");
		});
		self.data.fields.time.on("invalid", function(e) {
			e.target.setCustomValidity("Please select a time");
		});
		self.data.fields.partySize.on("invalid", function(e) {
			e.target.setCustomValidity("Please select your party size");
		}).on("selecta-init", function() {
			if (self.data.$module.attr("data-module-version") != "modal")
			frc.animations.reservations(self.data.$module);
		});

		for(i in self.data.fields){
			self.data.fields[i].on("change", function(e){
				e.target.setCustomValidity("");
			});
		}

		self.data.$module.find("select").Selecta({
			firstAsPlaceholder: true,
			nativeOnMobile: true
		});

		// Initialize jQuery Datepicker
		self.initializeDatepicker();

		self.data.fields.date.on("input change", function(){
			var today =	new Date(
				(new Date().getMonth()+1) + "/" +
				(new Date().getDate()) + "/" +
				(new Date().getFullYear())
			);

			var userSelectedToday = new Date(this.value).toString() == today.toString();
			self.populateTimeField(userSelectedToday);
		});

		// Populate times
		self.populateTimeField();

		self.data.fields.location.on("change", function() {
			var $option = self.data.fields.location.find('option[value="'+ self.data.fields.location.val() +'"]');
			var phone = $option.attr('data-phone');
			var maxReservationSize = window.parseFloat($option.attr('data-max-reservation-size') || 8);

			// Toggle private dining message
			if (phone) {
				// Format from xxx-xxx-xxxx to xxx.xxx.xxxx
				phone = phone.replace(new RegExp('-', 'g'), '.');
				// Append Phone number
				self.data.$module.find(".private-dining-message")
					.html("For parties over " + maxReservationSize + ", please call <a href=\"tel:" + phone + "\">" + phone + "</a>");
					self.data.$module.find(".private-dining-message-wrapper").addClass('active');
			} else {
				var privateDiningUrl = "/group-dining/";
				// Append Group Dining internal link
				self.data.$module.find(".private-dining-message")
					.html('For private dining and events, visit our <a href="' +  privateDiningUrl + '">Group Dining</a> page');

				self.data.$module.find(".private-dining-message-wrapper").addClass('active');
			}

			// Update Party Size dropdown if the number is different
			if(self.data.fields.partySize.find("option:last-of-type").val()!=maxReservationSize){
				self.populatePartySizeField(maxReservationSize);
			}
		});

		// Autoselect location
		if(frc.data.user.nearestOpenTableLocation){
			self.selectLocation();
		}
		$(frc).on("nearestopentablelocationdetermined", function(){
			self.selectLocation();
		});

		self.data.$form = $module.find("form");

		self.data.$form.on("submit", function(e) {
			var inlineErrors = false;
			self.data.fields.date.attr('readonly', false);
			self.data.fields.date.attr('required', true);

			if (self.data.version == "modal") {
				inlineErrors = true;
			}

			if (!frc.utilities.validateForm(self.data.$form, inlineErrors)) {
				self.data.fields.date.attr('required', false);
				self.data.fields.date.attr('readonly', true);
			}
			else {
				var $option = self.data.fields.location.find('option[value="'+ self.data.fields.location.val() +'"]');
				var openTableID = $option.attr("data-opentable-id");

				var time = self.data.fields.time.val();
				var fmtHours = Number(time.match(/^(\d+)/)[1]);
				var fmtMinutes = Number(time.match(/:(\d+)/)[1]);
				var fmtAMPM = time.match(/\s(.*)$/)[1];

				if (fmtAMPM == 'PM' && fmtHours < 12) {
					fmtHours += 12;
				}
				if (fmtAMPM == 'AM' && fmtHours == 12) {
					fmtHours -= 12;
				}

				var hour = fmtHours.toString(),
					min = fmtMinutes.toString();

				if (fmtHours < 10) { hour = '0' + hour; }
				if (fmtMinutes < 10) { min = '0' + min; }

				var fmtTimeStamp = hour +':'+ min;

				var dateTime = window.escape(self.data.fields.altDate.val() + "T" + fmtTimeStamp);

				var url = "https://www.opentable.com/restaurant/profile/" + openTableID + "/reserve?restref=" + openTableID + "&datetime=" + dateTime + "&searchdatetime=" + dateTime + "&covers=" + self.data.fields.partySize.val() + "&partysize=" + self.data.fields.partySize.val();

				window.open(url);

				// Fire off event for analytics
				$(frc).trigger("reservationformsubmitted", {
					"locationId": self.data.fields.location.val(),
					"locationName": $option.text(),
					"date": self.data.fields.date.val(),
					"time": time,
					"partySize": self.data.fields.partySize.val(),
					"actionUrl": url,
					"version": self.data.version
				});
			}
			e.preventDefault();
		});

	}

	/**
	 * Method that initializes a jQuery datepicker inside a given DOM element
	 *
	 * Automatically called at reservation form load time, and also after a
	 * TripleSeat modal is added to the page (ensures that TripleSeat's own Datepicker
	 * does not steal focus).
	 */
	self.initializeDatepicker = function () {
		var minDate = new Date();

		// If it's later than 10:15 pm, do not accept anymore reservations for today
		if (minDate.getHours() === 22 && minDate.getMinutes() > 15) {
			minDate.setDate(minDate.getDate()+1);
		}

		self.data.fields.date.datepicker({
        	"minDate": minDate,
        	"altField": self.data.fields.altDate,
        	"altFormat": "yy-mm-dd",
        	"maxDate": 90, // max date = 90 days from now, which seems to be OpenTable's limit
			"beforeShow": function() {
				$('.ui-datepicker').show();
				// Change z-index of datepicker if shown in a modal
				self.data.fields.date.parent().addClass('datepicker-open');
				if (self.data.$module.parents(".jquery-modal").length) {
					window.setTimeout(function(){
						$('#ui-datepicker-div').css('z-index', 9999);
						// $('#ui-datepicker-div').css('border', '2px solid blue');
					}, 0);
				}
			},
			"onSelect": function() {
			},
			"onClose": function() {
				$('.ui-datepicker').hide();
				self.data.fields.date.parent().removeClass('datepicker-open');
			}
        });
	}

	self.populateTimeField = function(isToday){

		var startDatetime;
		var startDay;

		if(!isToday || new Date().getHours()<11){
			// If user selected a future date or it's currently before 11am, start at 11am
			startDatetime = new Date(1970, 0, 1, 11, 0, 0, 0);
		} else {
			// If the user selected today and it's after 9am, start with whatever the current time is, rounded up to the nearest half-hour increment
			startDatetime = new Date(Math.ceil(new Date().getTime() / 1800000) * 1800000);
		}

		if(self.data.startDatetime != startDatetime.toString()){
			self.data.startDatetime = startDatetime.toString();

			var currentVal = self.data.fields.time.val();
			self.data.fields.time.empty();
			self.data.fields.time.append('<option value="" class="selecta-placeholder">Time</option>');

			// Bail out before we reach 11pm
			var startHour = window.parseFloat(startDatetime.getHours());
			var i = startHour;
			if(startDatetime.getMinutes()){
				i += .5;
			}
			for(; i<23; i+=.5){

				var hourVal = Math.floor(i);
				var amPM = " AM";
				if(hourVal>11){
					amPM = " PM";
				}
				if(hourVal>12){
					hourVal -= 12;
				}

				var timeVal = hourVal + ":" + (i===Math.floor(i)?"00":"30") + amPM;
				self.data.fields.time.append('<option value="'+ timeVal +'">'+ timeVal +'</option>');
			}

			self.data.fields.time.val(currentVal);
			self.data.fields.time.Selecta('refresh');
		}
	}

	self.populatePartySizeField = function(maxReservationSize){
		var currentVal = self.data.fields.partySize.val();
		self.data.fields.partySize.empty();
		self.data.fields.partySize.append('<option value="" class="selecta-placeholder">Party Size</option>');
		for (var i = 1; i <= maxReservationSize; i++) {
			self.data.fields.partySize.append('<option value="'+ i +'">'+ i +'</option>');
		}
		// Restore previous val
		self.data.fields.partySize.val(currentVal);
		self.data.fields.partySize.Selecta('refresh');
	}

	self.selectLocation = function(){
 		if(frc.data.user.nearestOpenTableLocation && frc.data.user.nearestOpenTableLocation.id){
 			self.data.fields.location.val(frc.data.user.nearestOpenTableLocation.id);
 			self.data.fields.location.Selecta('refresh');
			self.data.fields.location.trigger('change');
 		}
	}

	self.init();
	return self;

}
